declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initFBPixel(pixelId: string) {
  if (initialized || typeof window === 'undefined') return

  try {
    const f = window as any
    const b = document
    const e = 'script'
    const v = 'https://connect.facebook.net/en_US/fbevents.js'

    if (f.fbq) return

    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v

    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }

    window.fbq('init', pixelId)
    initialized = true
  } catch (err) {
    console.warn('FB Pixel init failed:', err)
  }
}

export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  } catch (err) {
    console.warn('FB Pixel PageView failed:', err)
  }
}

export function trackAddToCart(data?: Record<string, any>) {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', data)
    }
  } catch (err) {
    console.warn('FB Pixel AddToCart failed:', err)
  }
}
